export default {
  namespaced: true,
  state: {
    roleConfigs: [
      {title: 'Báo cáo', value: 'report'},
      {title: 'Hồ sơ xét tuyển', value: 'cv'},
      {title: 'Chi tiết hồ sơ xét tuyển', value: 'cvDetail'},
      {title: 'Kết quả', value: 'result'},
      {title: 'Nhập học', value: 'enroll'},
      {title: "Hủy nhập học", value: 'cancelDocument'},
      {title: 'Xét duyệt nhập học & chuyển hệ đào tạo', value: 'admission'},
      {title: 'Đào tạo & Khảo thí', value: 'exam'},
      {title: 'CRM', value: 'sale'},
      {title: 'Thông báo', value: 'notification'},
      {title: 'Sự kiện & Thông tin', value: 'information'},
      {title: 'Phân quyền', value: 'setting'}
    ],
    refundAllowList: [
      '0117058077',
      '0117062900',
      '0117063070',
      '0117063080',
      '0117746228',
      '0117792404',
      '0117792496',
      '0117797680',
      '0117798022',
      '0117851012',
      '0117883973',
      '0117909719',
      '0117967550',
      '0117981095',
      '0118005399',
      '0118005769',
      '0118010195',
      '0118077554',
      '0118080528',
      '0118109040',
      '0118128008',
      '0118128414',
      '0118128448',
      '0118129143',
      '0118176886',
      '0118177307',
      '0118202674',
      '0118203130',
      '0118435983',
      '0128724964',
      '0128724965',
      '0129541255',
      '0130486882',
      '0131673697',
      '0131820089',
      '0131987144',
      '0132056455',
      '0132101754',
      '0132369093',
      '0133602874',
      '0134076064',
      '0134396263',
      '0134565355',
      '0134565425',
      '0138564858',
      '0138716866',
      '0139149573',
      '0139407593',
      '0141316649',
      '0142160650',
      '2728484828',
      '3317716984',
      // DEMO ACCOUNT
      '3333333333'
    ]
  },
  getters: {
    roleConfigs: state => state.roleConfigs,
    refundAllowList: state => state.refundAllowList
  }
}
